import EcoImg from 'eco-design/base/eco-img';
import { useOnceInView } from '../useOnceInView';
import css from './index.module.scss';
import { useLang } from '@/i18n';

function TheComp() {
    const { t } = useLang('theProduct');

    useOnceInView('.on-the-road-D .D-title', () => {
        document.querySelector('.D-title')?.classList.add('enter');
        document.querySelector('.D-subtitle')?.classList.add('enter');
        document.querySelector('.D-desc')?.classList.add('enter');
    });

    return (
        <section
            className={`${css.section} on-the-road-D GtmModuleData-section`}
            id="on-the-road-D"
            data-section-id={'on-the-road-D'}
            data-section-title={t('D_title')}
        >
            <EcoImg
                pc="https://websiteoss.ecoflow.com/figma-uploads/1767839719087-plgb8o-compressed-full-width-carousel.jpg"
                pad="https://websiteoss.ecoflow.com/figma-uploads/1767839724878-g5ct8d-compressed-Frame%202094654943.jpg"
                h5="https://websiteoss.ecoflow.com/figma-uploads/1767839729568-md7ob7-compressed-Frame%202094654942.jpg"
                isOpenLazy
            />
            <div className="D-info">
                <div className="D-title ani-1">{t('D_title')}</div>
                <div className="D-subtitle ani-2">{t('D_subtitle')}</div>
                <div className="D-desc ani-3">{t('D_desc')}</div>
            </div>
        </section>
    );
}

export default TheComp;
